import { render } from "./IPAddressTracker.vue?vue&type=template&id=e498db40&ts=true"
import script from "./IPAddressTracker.vue?vue&type=script&lang=ts"
export * from "./IPAddressTracker.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__